import { customerAddressFormStyles } from "@insite/content-library/Components/CustomerAddressForm";
import { css } from "styled-components";

customerAddressFormStyles.cancelButton = {
    color: "secondary",
    css: css`
        margin-right: 10px;
        font-family: "Roboto-Medium";
    `,
};

customerAddressFormStyles.submitButton = {
    css: css`
        font-family: "Roboto-Medium";
    `,
};
